export default "__VITE_ASSET__3dSzcCsx__"